import { Box } from '@mui/material';
import type { FC } from 'react';

import { requiredLabel } from '@core/utils/strings';

import { Input } from '../Input/Input';

type Props = {
  requiresContactInfo?: boolean;
  requiresContactEmail?: boolean;
  name: string;
  // Optional prefix for field names, defaults to 'contact'
  fieldPrefix?: string;
};

export const ContactField: FC<Props> = ({
  requiresContactInfo,
  requiresContactEmail,
  name,
  fieldPrefix = 'contact',
}) => {
  const getFieldName = (field: string): string =>
    fieldPrefix === '' ? `${name}.${field}` : `${name}.${fieldPrefix}.${field}`;

  return (
    <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
      <Input
        sx={{ flex: 1, flexBasis: 160 }}
        name={getFieldName('firstName')}
        label='First name*'
      />
      <Input sx={{ flex: 1, flexBasis: 160 }} name={getFieldName('lastName')} label='Last name*' />
      <Input
        sx={{ flex: 1, flexBasis: 160 }}
        name={getFieldName('jobTitle')}
        label={requiredLabel('Job title', requiresContactInfo)}
      />
      <Input
        sx={{ flex: 1, flexBasis: 160 }}
        name={getFieldName('emailAddress')}
        label={requiredLabel('Email', requiresContactInfo || requiresContactEmail)}
      />
      <Input
        sx={{ flex: 1, flexBasis: 160 }}
        name={getFieldName('phoneNumber')}
        label={requiredLabel('Phone number', requiresContactInfo)}
        type='tel'
      />
    </Box>
  );
};
